import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { IsgridsplitterService } from '../../../../is-form-builder/src/lib/isgridsplitter.service';
import { ComponentsService } from '@ic-builder/is-base';
import { SetSplitterProperty } from '../../../../is-form-builder/src/lib/isformbuilder.action';

@Component({
  selector: 'issplitterpicker',
  templateUrl: './issplitterpicker.component.html',
  styleUrls: ['./issplitterpicker.component.scss'],
})
export class IssplitterpickerComponent implements OnInit {
  splitterForm: FormGroup = new FormGroup({
    splitters: new FormControl(false),
  });

  constructor(
    private store: Store,
    private gridsplitter: IsgridsplitterService,
    private compserv: ComponentsService
  ) {}

  ngOnInit(): void {
    this.splitterForm.valueChanges.subscribe((a) => {
      this.store.dispatch(new SetSplitterProperty(a.splitters));
      const elements = document.getElementsByTagName('*');
      // let elements = document.querySelectorAll('_isid');
      const grids = [];
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (
          window.getComputedStyle(el).display === 'grid' &&
          el.attributes['_isid']
        ) {
          grids.push(el);
        }
      }
      if (a.splitters) {
        grids.forEach((grid) => {
          this.compserv.resizableSplitters(grid);
          this.gridsplitter.addSplitters(grid);
        });
      } else {
        grids.forEach((grid) => {
          this.compserv.removeSplitterHandlers();
          this.gridsplitter.removeGrid(grid);
        });
      }
    });
  }
}
